import React from "react";
import { useParams } from "react-router-dom";

const Questionlist = ({ QuestionList, setQuestionList, Remark, setRemark }) => {
  const { id, type, child_id, qtype } = useParams();

  const OptionHandler = (id, value, index) => {
    let Duplicate = QuestionList;
    Duplicate[index] = { ...Duplicate[index], given_answer: value };
    setQuestionList(() => [...Duplicate]);
  };
  return (
    <div className="p-5 mt-8 h-[75%] overflow-y-auto max-[740px]:h-auto max-[740px]:mt-0">
      {QuestionList?.map((item, index) => {
        return (
          <div className="border-b-2 pb-2" key={index}>
            <h3 className="font-semibold py-2 text-md">
              Q{index + 1}.{item?.question_text}
            </h3>

            <div className="flex flex-wrap">
              {[...new Array(5)].map((opt, optindex) => {
                return (
                  <div
                    className={`px-3 m-2 flex items-center rounded ${
                      String(item?.given_answer) != null &&
                      String(item?.given_answer) != ""
                        ? optindex == String(item?.given_answer)
                          ? "bg-[#7cd5fd]"
                          : "bg-[#ccc9]"
                        : "bg-[#ccc9]"
                    }  cursor-pointer`}
                    key={optindex}
                  >
                    <input
                      type="radio"
                      name={item?.question_id}
                      value={optindex}
                      checked={
                        String(item?.given_answer) != null &&
                        String(item?.given_answer) != ""
                          ? optindex == String(item?.given_answer)
                            ? true
                            : false
                          : false
                      }
                      id={optindex + 1 + "_" + item?.question_id}
                      onChange={(e) =>
                        OptionHandler(
                          `option_${optindex + 1}`,
                          e.target.value,
                          index
                        )
                      }
                      className="mr-2 cursor-pointer hidden"
                    />
                    <label
                      htmlFor={optindex + 1 + "_" + item?.question_id}
                      className="py-2 block font-medium text-sm cursor-pointer"
                    >
                      {item[`option_${optindex + 1}`]}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      {qtype == 2 ? (
        <div className="flex flex-col">
          <label htmlFor="" className="my-3 font-semibold">
            Remark
          </label>
          <textarea
            cols="30"
            rows="10"
            value={Remark}
            onInput={(e) => setRemark(e.target.value)}
            className="w-full border-2 p-2 h-32 rounded-md"
          ></textarea>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Questionlist;
